import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Star.svg",
  "use": "Star.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Star.svg\"><path d=\"M42.9967,35.8971l4.9055,15.6137A1.89,1.89,0,0,1,45,53.6453L31.9995,43.8467,19.0252,53.64a1.89,1.89,0,0,1-2.8933-2.1441l4.87-15.5761L7.83,26.4607a1.9124,1.9124,0,0,1,1.0881-3.4662H25.1447L30.208,7.3322a1.8761,1.8761,0,0,1,3.5828,0l5.0633,15.6623h16.28a1.9124,1.9124,0,0,1,1.0866,3.4672Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol